import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormService } from 'app/services/form.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-substance-binds-to-target',
  templateUrl: './substance-binds-to-target.component.html',
  styleUrls: ['./substance-binds-to-target.component.scss']
})
export class SubstanceBindsToTargetComponent implements OnInit, OnDestroy {
  bindsToTarget!: string;
  private formSubscription!: Subscription;
  private sizeChangeSubscription!: Subscription;
  private mobileDeviceSize: boolean = false;

  constructor(private responsive: BreakpointObserver, private formService: FormService) { }

  ngOnInit(): void {
    this.bindsToTarget = this.currentForm.get('substanceBindsToTarget')?.value;
    this.sizeChangeSubscription = this.responsive.observe([Breakpoints.Handset]).subscribe(result => {
      if (result.matches) {
        this.mobileDeviceSize = true;
      } else {
        this.mobileDeviceSize = false;
      }
    });
     this.formSubscription = this.formService.getCurrentUsanFormUpdate().subscribe(
      usanForm => {
         this.bindsToTarget = usanForm.value.get('substanceBindsToTarget')?.value;
      });
  }

  ngOnDestroy(): void {
    this.sizeChangeSubscription.unsubscribe();
    this.formSubscription.unsubscribe();
  }

  get isMobileDeviceSize(): boolean {
    return this.mobileDeviceSize;
  }

  updateBindsValue(value: string) { 
    if(!value) {
      return;
    }

    this.bindsToTarget = value;
    if(!this.bindsToTarget || (this.bindsToTarget !== 'Yes' && this.bindsToTarget !== 'No')) {
      return;
    }
    
    this.formService.updateUsanFormValue('substanceBindsToTarget', this.bindsToTarget);
  }

  errorCheck() {
    const targetControl = this.currentForm.get('substanceBindsToTarget');
    
    
    if(!targetControl) {
      return;
    }
    
    // Force re-validation
    setTimeout(() => {
      targetControl.markAsTouched();
      targetControl.markAsDirty();
      targetControl.updateValueAndValidity();
    });
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

  compareFn(value: string): boolean {
    return value == this.bindsToTarget;
  }

  public hasFieldValidationError(fieldName: string, errorName?: string): boolean {
    return this.formService.hasFieldValidationError(fieldName, errorName);
  }
}
